import './BrandLogo.css';

export default function BrandLogo({ className = '', variant = 'wordmark' }) {
  const iconOnly = variant === 'icon';
  const source = iconOnly ? 'dt-icon.png' : 'dt.png';

  return (
    <span className={`brand-logo ${iconOnly ? 'brand-logo--icon' : ''} ${className}`.trim()}>
      <img src={`${process.env.PUBLIC_URL || ''}/${source}`} alt="Data Tallied" />
    </span>
  );
}